/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_viewer">;
    readonly " $refType": "SbRespRefineMenuDrawer_viewer";
};
export type SbRespRefineMenuDrawer_viewer$data = SbRespRefineMenuDrawer_viewer;
export type SbRespRefineMenuDrawer_viewer$key = {
    readonly " $data"?: SbRespRefineMenuDrawer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawer_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuDrawer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '5bf5ef49032bf59bafa4069b0dbe702d';
export default node;
